var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#F2F4F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C14.5166 8.5 13.0666 8.93987 11.8332 9.76398C10.5999 10.5881 9.63856 11.7594 9.07091 13.1299C8.50325 14.5003 8.35472 16.0083 8.64411 17.4632C8.9335 18.918 9.64781 20.2544 10.6967 21.3033C11.7456 22.3522 13.082 23.0665 14.5368 23.3559C15.9917 23.6453 17.4997 23.4968 18.8701 22.9291C20.2406 22.3614 21.4119 21.4001 22.236 20.1668C23.0601 18.9334 23.5 17.4834 23.5 16C23.5 15.0151 23.306 14.0398 22.9291 13.1299C22.5522 12.2199 21.9997 11.3931 21.3033 10.6967C20.6069 10.0003 19.7801 9.44781 18.8701 9.0709C17.9602 8.69399 16.9849 8.5 16 8.5ZM16 22C14.8133 22 13.6533 21.6481 12.6666 20.9888C11.6799 20.3295 10.9109 19.3925 10.4567 18.2961C10.0026 17.1997 9.88378 15.9933 10.1153 14.8295C10.3468 13.6656 10.9182 12.5965 11.7574 11.7574C12.5965 10.9182 13.6656 10.3468 14.8295 10.1153C15.9933 9.88378 17.1997 10.0026 18.2961 10.4567C19.3925 10.9108 20.3295 11.6799 20.9888 12.6666C21.6481 13.6533 22 14.8133 22 16C22 17.5913 21.3679 19.1174 20.2426 20.2426C19.1174 21.3679 17.5913 22 16 22Z",
    fill: "#FF4D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 15.25H13.75C13.5511 15.25 13.3603 15.329 13.2197 15.4697C13.079 15.6103 13 15.8011 13 16C13 16.1989 13.079 16.3897 13.2197 16.5303C13.3603 16.671 13.5511 16.75 13.75 16.75H18.25C18.4489 16.75 18.6397 16.671 18.7803 16.5303C18.921 16.3897 19 16.1989 19 16C19 15.8011 18.921 15.6103 18.7803 15.4697C18.6397 15.329 18.4489 15.25 18.25 15.25Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactiveIcon.f10d5a52a27d1693e876c9e4d574f7ec.svg";
export { ForwardRef as ReactComponent };